import React, { Component } from 'react';
import UslugeNaslovna from '../../images/spash2.jpg';

var UslugeNaslovnaImg = {
	backgroundImage: `url(${UslugeNaslovna})`
};

export default class ContactPage extends Component {

	render () {
		return (

            <main>

		      <section className="usluge-first" style={ UslugeNaslovnaImg }></section>

		      <section className="usluge-second">
		          <div className="left-text">
		            <h1 className="usluge-title-orange">SERVICES</h1>
		            <h3>MARKETING CONSULTING</h3>
		              <p>It is an imperative for every company that works in the market environment to develop an approach strategy on the market in order to adapt more easily to constantly changing surroundings, win over the consumer whose expectations grow constantly, and fight with the competitors who have very similar strivings! And all of that in the digital era, so specific for the business of every company!</p>
		              <p>SMART helps you and your company analyze specific market situations which the company finds itself in at a given time and by analyzing your company and your brand, analyzing the competition and other external factors, suggest its successful appearance on the market.</p>
		              <p>Creating the kind of product sets (or services), prices, promotions and distribution, which will have the potential to find its place on the market, develop the existing one or take over the one from competitors, is a real marketing art. As any art, this too is both beautiful and hard. Last, but not least – it is budget sensitive. That is why Smart offers a series of solutions for overcoming these challenges!</p>
		          </div>
		          <div className="right-text">
		            <p><b>SMART</b> offers the following services:</p>
		              <ul className="list-usluge">
		                <li><i className="fas fa-square-full"></i><span>CREATING MARKETING STRATEGIES</span> (defining the client’s strategic goals, business strategies for achieving them, defining the mission, vision, marketing tactics and operational plans for its implementation)
						</li>
		                <li><i className="fas fa-square-full"></i><span>MEDIA BUYING</span></li>
		                <li><i className="fas fa-square-full"></i><span>DESIGNING ALL PROMOTIONAL TOOLS</span></li>
		                <li><i className="fas fa-square-full"></i><span>WEB & SOCIAL MEDIA</span></li>
		                <li><i className="fas fa-square-full"></i><span>EVENT ORGANIZATION</span></li>
		                <li><i className="fas fa-square-full"></i><span>PR & COPYWRITING</span></li>
		                <li><i className="fas fa-square-full"></i><span>PRODUCTION</span> (TV, web, radio, print)</li>
		              </ul>
		          </div>
		      </section>

	      <section className="clearfix usluge-third">
	        <div className="slika"><img src="/img/mediji.png" alt="usluge mediji"/></div>
	        <h3>MEDIA BUYING</h3>
	        <div className="media-div">
			        <div className="col-width1">
			          <p>IN THE WORLD OF MEDIA, WE HAVE ALREADY BEEN “SWIMMING” FOR 10 YEARS AND HAVE BRAVELY AND SUCCESSFULLY ACHIEVED GOALS SET FOR OUR CLIENTS</p>
			          <p>Choosing the right media mix, which will provide the client with campaign’s expected results, was always a real art, and in these days of the dominance of the new, digital media and almost “personalized” media scene, where the individuals are often more important relayers of messages than mass media, media buying is an even bigger challenge!</p>
			        </div>
			        <div className="col-width2">
			          <p>Smart Agency has an excellent cooperation with all of media segments, the traditional (national, regional and local TV and radio stations), print media (magazines and daily newspapers), Out of Home providers (billboard and city light providers, providers of vehicle branding and branding of other public areas), new media (news portals, lifestyle portals and similar), and last but not least – its own team for working with social media. Simultaneously, Smart Agency also cooperates with the biggest regional and international media buying agencies.</p>
			        </div>
			        <div className="col-width3">
			          <p>How to reach a consumer within the modern generation, how to choose from the mixture of social media the one which will achieve the highest level of interaction with consumers and have biggest influence, whether and how much digital web advertising makes sense and has an effect and how to combine all of that with advertising on TV, radio and in print – that is our job and the task in which we excel!</p>
			        </div>
			</div>
	      </section>

	      <section className="usluge-four">
	        <div className="slika"><img src="/img/slika-sladoled.png" alt="usluge"/></div>
	        <div className="media-div1">
		        <div className="col-width-ice1">
		            <h3><span className="one">A</span><span className="two">R</span><span className="three">T</span>, CREATION, DESIGN</h3>
		            <p>The visual identity of your company, new visualization of the company or product, logo, original corporate material – all of that represents a creative challenge for our SMART design team. SMART creations are always a blend of clear business message and artistic expression.</p>
		        </div>
		        <div className="col-width-ice2">
		          <p><b>SMART</b> offers the following services:</p>
		          <ul>
		            <li><span>Graphic design of the corporate package (company or brand logo, book of graphic standards, business materials…)</span></li>
		            <li><span>Design and product development (packaging design, labels, the product as a whole…)</span></li>
		            <li><span>Design of ATL promotional tools (billboards and various promotional tools for OOH advertisement, advertisements for print or digital media, social media, etc.)</span></li>
		            <li><span>Design of BTL promotional tools (major and “small” POS materials, catalogues, fliers…)</span></li>
		            <li><span>Web design</span></li>
		            <li><span>Design of booths and other company appearances at business events</span></li>
		          </ul>
		        </div>
		    </div>
	      </section>

	      <section className="clearfix usluge-five media-div1">
	          <div className="image-absolute col-width-ice1"><img src="/img/www.png" alt="usluge"/></div>
	          <div className="right-col col-width-ice1">
	            <div className="col-top">
	                <h3><b>WEB & SOCIAL</b> MEDIA</h3>
	                <p>Our experience in the field of web design, as well as constant adaptation to new trends and achievements, enables us to offer our clients professional SMART services and quality designs. To have a top quality web site that is rich in content and visually appealing – that is a promising prospect for your business.</p>
	                <p>SMART team successfully takes care of your image on social media, from creating posts, texts, communication with influencers to analytics.</p>
	            </div>
	            <div>
	              <p><b>SMART</b> offers the following services:</p>
	              <ul>
	                <li><span>CONCEPTUAL STRUCTURAL PLANNING OF THE WEB SITE</span></li>
	                <li><span>WEB DESIGN</span></li>
	                <li><span>PROGRAMMING</span></li>
	                <li><span>OPTIMIZATION OF WEB SITES FOR SEARCH ENGINES</span></li>
	                <li><span>SUPPORT AND MAINTENANCE OF WEB SITES</span></li>
	                <li><span>CAMPAIGNS ON SOCIAL MEDIA</span></li>
	              </ul>
	            </div>
	          </div>
	      </section>

	      <section className="usluge-six media-div1">
	          <div className="col-width-ice1">
	            <div className="col-top">
	                <h3>EVENT ORGANIZATION</h3>
	                <p>How to most effectively organize appearances on fairs, promotional events, ceremonies, business cocktails? SMART creative team successfully organizes your special events – from invitations, decorations, menu choice, accompanying program, to guest turn outs and media support. SMART plans, designs and realizes every detail. You will be the talk of the town…</p>
	            </div>
	            <div>
	              <p><b>SMART</b> offers the following services:</p>
	              <ul>
	                <li><span>APPEARANCES ON FAIRS</span></li>
	                <li><span>PROMOTIONS</span></li>
	                <li><span>CEREMONIES</span></li>
	                <li><span>IMPORTANT DATES</span></li>
	                <li><span>SPONSORSHIPS</span></li>
	              </ul>
	            </div>
	          </div>

	          <div className="image-baloni col-width-ice2"><img src="/img/baloni.png" alt="usluge"/></div>
	      </section>

	      <section className="usluge-seven media-div1">
	          <div className="image-absolute col-width-ice1"><img src="/img/poruka.png" alt="usluge"/></div>
	          <div className="right-col col-width-ice2">
	            <div className="col-top">
	                <h3>PR & COPYWRITING</h3>
	                <p>A good reputation of your business is the main task of the PR. There are a lot of SMART ways for the public to perceive you exactly the way you want it to. The success of your business depends on the interpretation of your goals and results. SMART solutions will differentiate you from the competition, make you interesting to both the public and media.</p>
	                <p>Copywriting is one of the essential elements of marketing. Whether you want to sell, lobby, promote, persuade… you will need SMART “stories” which intrigue people whose opinion your business depends on.</p>
	            </div>
	            <div>
	              <p><b>SMART</b> offers:</p>
	              <ul>
	                <li><span>Planning and organization of PR campaigns</span></li>
	                <li><span>Creation of unique ideas for campaigns</span></li>
	                <li><span>Creation of slogans and headlines</span></li>
	                <li><span>PR texts, newspaper articles, catalogue texts, web sites…</span></li>
	              </ul>
	            </div>
	          </div>
	      </section>

	      <section className="usluge-six media-div1">
	          <div className="col-width-ice1">
	            <div className="col-top">
	                <h3><b>PRODUCTION</b></h3>
	                <p>Smartly designed and artistically shaped media message is the main task of the SMART production team.</p>
	            </div>
	            <div>
	              <p><b>SMART</b> offers:</p>
	              <ul>  
	                <li><span>PRODUCTION OF TV COMMERCIALS</span></li>
	                <li><span>PRODUCTION OF CORPORATE FILMS</span></li>
	                <li><span>PRODUCTION OF RADIO COMMERCIALS</span></li>
	                <li><span>PRODUCTION OF CONTENT FOR PRINT ADVERTISEMENT</span></li>
	                <li><span>PRODUCTION OF CONTENT FOR WEB/SOCIAL NETWORKS (VIDEO, GIFF, ANIMATION, GRAPHICS)</span></li>
	              </ul>
	            </div>
	          </div>

	          <div className="image-mediji col-width-ice2"><img src="/img/mediji-cartoon.png" alt="usluge"/></div>
	      </section>

            </main>
        )
    }

}


// WEBPACK FOOTER //
// ./src/components/English/UslugeEnglishPage.js